import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const ChannelBasicInfoComponent = ({ handleInnerbasicFormChange, selectedChannels, stores }: any) => (
          <>
  <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
         <InputContainer
             isDisabled="chosenChannels.Id"
             label="Store Name"
             labelField="StoreName"
             list={stores}
             onValueChange={(event: any, newValue: any) => {
               handleInnerbasicFormChange(
                 event.target.value,
                 'StoreId'
               );
             }}
             optionName='Choose Store'
             type="select"
             value={selectedChannels?.StoreId}
             valueField="Id"
         />
       <InputContainer
              isDisabled="chosenChannels.Id"
              label="SalesChannel Name"
              name="SalesChannel Name"
              onValueChange={(event: any) => {
                handleInnerbasicFormChange(
                  event.target.value,
                  'SalesChannelName'
                )
              }}
              type="text"
              value={selectedChannels?.SalesChannelName}
          />
      <InputContainer
              isDisabled="chosenChannels.Id"
              label="DisplayOrder"
              name="DisplayOrder"
              onValueChange={(event: any) => {
                handleInnerbasicFormChange(
                  event.target.value,
                  'DisplayOrder'
                )
              }}
              type="number"
              value={selectedChannels?.DisplayOrder}
          />
    <InputContainer
              isDisabled="chosenChannels.Id"
              label="Remarks"
              name="Remarks"
              onValueChange={(event: any) => {
                handleInnerbasicFormChange(
                  event.target.value,
                  'Remarks'
                )
              }}
              type="text"
              value={selectedChannels?.Remarks}
          />
    </div>
 }
 expandedPanel="basicInfo"
 headerTitle="Basic Info"
/>
</>
)
export default ChannelBasicInfoComponent;
